export const LOAD_CHARTS = 'ethstats/historicalBlock/LOAD_CHARTS';
export const LOAD_CHARTS_SUCCESS = 'ethstats/historicalBlock/LOAD_CHARTS_SUCCESS';
export const LOAD_CHARTS_FAIL = 'ethstats/historicalBlock/LOAD_CHARTS_FAIL';
export const LOAD_NODES = 'ethstats/historicalBlock/LOAD_NODES';
export const LOAD_NODES_SUCCESS = 'ethstats/historicalBlock/LOAD_NODES_SUCCESS';
export const LOAD_NODES_FAIL = 'ethstats/historicalBlock/LOAD_NODES_FAIL';
export const CLEAR_ERRORS = 'ethstats/historicalBlock/CLEAR_ERRORS';

